<template>
  <TransitionGroup name="toast" tag="div" class="fixed z-[10000] flex flex-col gap-4 bottom-4 left-4 right-4 sm:left-auto sm:w-96">
    <MessageVue v-for="msg in store.toDisplay" :key="msg.id" :msg="msg" />
  </TransitionGroup>
</template>
<style>
/*
    Enter and leave animations can use different
    durations and timing functions.
  */
.toast-enter-active {
  transition: all 0.2s ease-out;
}

.toast-leave-active {
  transition: all 0.2s cubic-bezier(1, 0.5, 0.2, 1);
}

.toast-enter-from,
.toast-leave-to {
  transform: translateX(40px);
  opacity: 0;
}
</style>
<script setup lang="ts">
import { useToastStore } from '@/store/useToastStore';
import MessageVue from './Message.vue';

const store = useToastStore();
</script>
